import React from 'react';
import { saveAs } from 'file-saver';
import moment from 'jalali-moment'

const AnnouncementDetail = ({res}) => {
    const myDomain = "src=\"" + process.env.REACT_APP_BASE_URL;
    const getImagesWithAbsolutePath = (text, absolutePathPrefix) => {
        if (!text) return ''
        const regex =  new RegExp(`(?:src=\"\/*)+(.*?)`, "g")
        return text.replace(regex,  absolutePathPrefix + '/$1')
    }
    const buttonStyle = {
        width:"150px",
        height: '45px',
        padding: '1%',
        border: '1px solid red',
        backgroundColor: 'red',
        borderRadius: '12px',
        color: '#fff',
        margin: '2%',
        cursor:"pointer"
    }
    const saveFile = (url) => {
        saveAs(
            process.env.REACT_APP_BASE_URL + url
        );
      }

    return (  

    <article className="blog-post-details">
           
            <div className="blog-post-txt-wrap">
                <div className="row">
                    
                    <div className="col-md-3 col-lg-2 order-1 order-md-0">
                        <div className="author-info mt-sm-40">
                            <div className="author-thumb" style={{padding:"10%"}}>
                                <img src={process.env.REACT_APP_BASE_URL + res.announcement[0].announcementIcon.urls[0]} alt=''/>
                            </div>
                            <div className="author-txt">
                                <h5>{res.announcement[0].displayText}<span className="designation" > {moment(res.announcement[0].announcementDate, 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD') }</span></h5>
                                {/* <div className="member-social-icons">
                                    <a href='#' target="_blank" rel='noopener noreferrer'>
                                        <i className="fa fa-facebook"/>
                                    </a>
                                    <a href='#' target="_blank" rel='noopener noreferrer'>
                                        <i className="fa fa-twitter"/>
                                    </a>
                                    <a href='#' target="_blank" rel='noopener noreferrer'>
                                        <i className="fa fa-linkedin"/>
                                    </a>
                                </div> */}
                            </div>
                        </div>
                    </div>
                        
                    <div className={`m-auto order-0 col-md-12 col-lg-8`}>
                        <div className="blog-post-txt">
                            <div dangerouslySetInnerHTML={{__html: getImagesWithAbsolutePath(res.announcement[0].htmlBody.html, myDomain)}} />
                        </div>

                        {res.announcement[0].bag.contentItems[0] && res.announcement[0].bag.contentItems[0].__typename === 'AnnouncementDownload' && <div className="share-article text-center">
                          
                            <div style={buttonStyle} onClick={()=>saveFile(res.announcement[0].bag.contentItems[0].announcementFile.urls[0])}>دانلود </div>
                            
                        </div>}
                    </div>

                </div>
            </div>
        </article>
            
    );
}
 
export default AnnouncementDetail;